import { render, staticRenderFns } from "./PropertyBased.vue?vue&type=template&id=e5217842&scoped=true"
import script from "./PropertyBased.vue?vue&type=script&lang=js"
export * from "./PropertyBased.vue?vue&type=script&lang=js"
import style0 from "./PropertyBased.vue?vue&type=style&index=0&id=e5217842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5217842",
  null
  
)

export default component.exports